import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppActiveFiltersList from '@/components/common/AppActiveFiltersList.vue'
import InvoicesList from '@/components/invoices/InvoicesList.vue'
import AppFilteringForm from '@/components/common/AppFilteringForm.vue'
import {
    UiHeading,
    UiContainer,
    UiPagination,
    UiPopover,
    UiFiltersTrigger,
} from '@/components/common/ui'
import { AppLoadingContent, TheFallback } from '@/components/common/'
import { useInvoices, InvoiceListFilters } from '@/composables/useInvoices'
import { useFiltersStorage } from '@/composables/useFiltersStorage'
import { useInvoiceStatuses } from '@/composables/useInvoiceStatuses'
import { usePaginationUrlQuery } from '@/composables/usePaginationUrlQuery'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { currentPage, updateUrlQuery } = usePaginationUrlQuery()
const { currentFilters } = useFiltersStorage<InvoiceListFilters>('invoices')

const { fetchInvoices, invoices, loading, isEmpty } = useInvoices()
fetchInvoices({ page: currentPage.value, filters: currentFilters.value })

const { fetchInvoiceStatuses, invoiceStatuses } = useInvoiceStatuses()
fetchInvoiceStatuses()

const handleChangePage = (newPage: number) => {
    fetchInvoices({ page: newPage })
}

const handleFilter = (filters: InvoiceListFilters, close?: () => void) => {
    if (close) close()
    updateUrlQuery('1')
    fetchInvoices({ page: 1, filters })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Faktury" }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiPopover), {
          position: "stick-to-right",
          width: 400,
          "as-regular-popover-breakpoint": "md"
        }, {
          refferer: _withCtx(() => [
            _createVNode(_unref(UiFiltersTrigger), {
              "filters-length": _unref(currentFilters) && Object.keys(_unref(currentFilters)).length
            }, null, 8, ["filters-length"])
          ]),
          content: _withCtx(({ close }) => [
            _createVNode(AppFilteringForm, {
              "use-filter-storage": "invoices",
              "filters-schema": [
                        {
                            type: 'select',
                            key: 'status',
                            label: 'Status dokumentu',
                            options: _unref(invoiceStatuses).map(e => {
                                return { ...e, id: e.symbol }
                            }),
                        },
                    ],
              "cancel-button-text": "Usuń filtry",
              onSubmit: filters => handleFilter(filters as InvoiceListFilters, close)
            }, null, 8, ["filters-schema", "onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(UiContainer), null, {
      default: _withCtx(() => [
        _createVNode(AppActiveFiltersList, {
          clerable: "",
          "use-filter-storage": "invoices",
          class: "hidden md:flex",
          "filters-schema": [
                {
                    type: 'select',
                    key: 'status',
                    label: 'Status dokumentu',
                    options: _unref(invoiceStatuses).map(e => {
                        return { ...e, id: e.symbol }
                    }),
                },
            ],
          onRemoveFilter: _cache[0] || (_cache[0] = filters => handleFilter(filters as InvoiceListFilters))
        }, null, 8, ["filters-schema"]),
        _createVNode(_unref(AppLoadingContent), { "is-loading": _unref(loading) }, {
          default: _withCtx(() => [
            (_unref(isEmpty))
              ? (_openBlock(), _createBlock(_unref(TheFallback), { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(InvoicesList, {
                    invoices: _unref(invoices).items
                  }, null, 8, ["invoices"]),
                  _createVNode(_unref(UiPagination), {
                    "with-url-query": "",
                    class: "mt-12",
                    metadata: _unref(invoices).metadata,
                    onChangePage: handleChangePage
                  }, null, 8, ["metadata"])
                ], 64))
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _: 1
    })
  ], 64))
}
}

})